import { useState, useEffect } from 'react';

function getWindowWidth() {
  return typeof window === 'object' ? window.innerWidth : 0;
}

function useResize() {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(getWindowWidth());
    };

    if (typeof window === 'object') {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (typeof window === 'object') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return windowWidth;
}

export default useResize;
